export default __webpack_public_path__ + "static/home-2-1f2b936e99a5350e55344108829dd115.png";